import { render, staticRenderFns } from "./detalhes.vue?vue&type=template&id=c63f64fc&scoped=true"
import script from "./detalhes.vue?vue&type=script&lang=js"
export * from "./detalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f64fc",
  null
  
)

export default component.exports